export function CheckboxIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="1.94584" y="1.94633" width="16.1078" height="16.1078" rx="2.49833" stroke="#98A2B3" stroke-width="1.67" />
    </svg>
  );
}

CheckboxIcon.displayName = 'CheckboxIcon';
